module.exports = __webpack_public_path__ + "static/media/logout.8a5cc43a.svg";